import axiosInstance from './axiosInstance';

const normalizeList = (data, key) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data[key])) return data[key];
  if (data && Array.isArray(data.data)) return data.data;
  return [];
};

export const fetchOrders = async () => {
  const response = await axiosInstance.get('/orders');
  const list = normalizeList(response.data, 'orders') || normalizeList(response.data, 'data') || [];
  return list;
};

export const updateOrderStatus = async (orderId, newStatus) => {
  const response = await axiosInstance.patch(`/orders/${orderId}/status`, { status: newStatus });
  return response.data;
};

export const updatePaymentStatus = async (orderId, paymentStatus) => {
  const response = await axiosInstance.patch(`/orders/${orderId}/payment-status`, { payment_status: paymentStatus });
  return response.data;
};

